<template>
    <div v-if="!isLoading">
        <div style="margin-bottom: 30px;" v-if="notice">
            <Alert :message="'Ошибка! ' + notice" type="error"></Alert>
        </div>

        <div>
            <label @click="hiddenHandle();">В качестве кого зарегистрироваться:</label>
            <div id="role" style="margin-top: 15px;">
                <Select
                        v-model:value="role"
                        style="width: 360px; max-width: 100%"
												:options="roles"
								></Select>
<!--                <div class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_0"-->
<!--                           value="ROLE_PARTICIPANT" v-model="role">-->
<!--                    <label style="cursor: pointer" for="role_0">Участник</label>-->
<!--                </div>-->
<!--                <div class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_1"-->
<!--                           value="ROLE_EXPERT" v-model="role">-->
<!--                    <label style="cursor: pointer" for="role_1">Эксперт</label></div>-->
<!--                <div class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_2"-->
<!--                           value="ROLE_ORGANIZATOR" v-model="role">-->
<!--                    <label style="cursor: pointer" for="role_2">Организатор</label></div>-->
<!--                <div class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_3"-->
<!--                           value="ROLE_COMISSION" v-model="role">-->
<!--                    <label style="cursor: pointer" for="role_3">Кинокомиссия</label>-->
<!--								</div>-->
<!--                <div class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_4"-->
<!--                           value="Площадка" v-model="role">-->
<!--                    <label for="role_4">Площадка</label>-->
<!--                </div>-->
<!--                <div v-if="hiddenCounter > 5" class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_5"-->
<!--                           value="ROLE_COMPANY" v-model="role">-->
<!--                    <label style="cursor: pointer" for="role_5">Компания</label>-->
<!--                </div>-->
<!--                <div v-if="hiddenCounter > 5" class="checkbox__wrapper">-->
<!--                    <input @change="handleRadio" type="radio" id="role_6"-->
<!--                           value="вектор" v-model="role">-->
<!--                    <label v-if="hiddenCounter > 5" for="role_6">Участник кинофорума "Новый вектор"</label></div>-->
            </div>
        </div>

        <template v-if="role && role !== 'Площадка'">
						<template v-if="role === 'ROLE_COMPANY'">

                <BaseInput3
                        label="Почта"
                        v-model="email"
                        placeholder="Будет вашим логином на платформе. По этому логину вы сможете входить в свой личный кабинет"
                        objectKey="email"
                        @onChange="checkErrors(false)"
                ></BaseInput3>

                <BaseInputPassword
                        label="Пароль"
                        v-model="password"
                        objectKey="password"
                        :type="passwordShow ? 'text' : 'password'"
                        @onChange="checkErrors(false)"
                >
                    <template v-slot:footer>
                        <template v-if="passwordShow">
                            <FontAwesomeIcon @click="passwordShow = !passwordShow" icon="eye-slash"></FontAwesomeIcon>
                        </template>
                        <template v-else>
                            <FontAwesomeIcon @click="passwordShow = !passwordShow" icon="eye"></FontAwesomeIcon>
                        </template>
                    </template>
                </BaseInputPassword>
                <BaseInputPassword
                        label="Повторите пароль"
                        v-model="repeatPassword"
                        objectKey="repeatPassword"
                        :type="passwordRepeatShow ? 'text' : 'password'"
                        @onChange="checkErrors(false)"
                >
                    <template v-slot:footer>
                        <template v-if="passwordRepeatShow">
                            <FontAwesomeIcon @click="passwordRepeatShow = !passwordRepeatShow"
                                             icon="eye-slash"></FontAwesomeIcon>
                        </template>
                        <template v-else>
                            <FontAwesomeIcon @click="passwordRepeatShow = !passwordRepeatShow" icon="eye"></FontAwesomeIcon>
                        </template>
                    </template>
                </BaseInputPassword>

                <BaseInput3
                        label="Название компании"
                        v-model="firmName"
                        objectKey="firmName"
                        @onChange="checkErrors(false)"
                ></BaseInput3>

                <BaseInput3
                        label="Телефон"
                        v-model="phone"
                        objectKey="phone"
                        @onChange="checkErrors(false)"
                ></BaseInput3>

                <div id="user_form" class="field checkbox__wrapper">
                    <input @change="checkErrors(false)" type="checkbox" id="user_edit_data_accept" required="required"
                           v-model="allow">
                    <label class="req required" for="user_edit_data_accept">Я подтверждаю, что ознакомлен и принимаю <a
                            href="/license" target="_blank">пользовательское соглашение</a> и <a href="/policy"
                                                                                                 target="_blank">условия
                        конфиденциальности</a></label>
                </div>

                <div class="errors-block" v-show="errors.length">
                    <b>Пожалуйста, заполните поля:</b>
                    <ul>
                        <li style="color: red" v-for="(error,index) in errors" :key="index" v-html="error"></li>
                    </ul>
                </div>

                <div class="field" style="margin-top: 0.75rem;">
                    <button id="submit_button" style="width: 100%" class="button_login" @click="saveData">Регистрация
                    </button>
                </div>


						</template>
						<template v-else>
                <BaseInput3
                        label="Почта"
                        v-model="email"
                        placeholder="Будет вашим логином на платформе. По этому логину вы сможете входить в свой личный кабинет"
                        objectKey="email"
                        @onChange="checkErrors(false)"
                ></BaseInput3>

                <BaseInputPassword
                        label="Пароль"
                        v-model="password"
                        objectKey="password"
                        :type="passwordShow ? 'text' : 'password'"
                        @onChange="checkErrors(false)"
                >
                    <template v-slot:footer>
                        <template v-if="passwordShow">
                            <FontAwesomeIcon @click="passwordShow = !passwordShow" icon="eye-slash"></FontAwesomeIcon>
                        </template>
                        <template v-else>
                            <FontAwesomeIcon @click="passwordShow = !passwordShow" icon="eye"></FontAwesomeIcon>
                        </template>
                    </template>
                </BaseInputPassword>
                <BaseInputPassword
                        label="Повторите пароль"
                        v-model="repeatPassword"
                        objectKey="repeatPassword"
                        :type="passwordRepeatShow ? 'text' : 'password'"
                        @onChange="checkErrors(false)"
                >
                    <template v-slot:footer>
                        <template v-if="passwordRepeatShow">
                            <FontAwesomeIcon @click="passwordRepeatShow = !passwordRepeatShow"
                                             icon="eye-slash"></FontAwesomeIcon>
                        </template>
                        <template v-else>
                            <FontAwesomeIcon @click="passwordRepeatShow = !passwordRepeatShow" icon="eye"></FontAwesomeIcon>
                        </template>
                    </template>
                </BaseInputPassword>


                <BaseInput3
                        :label="nameLabel"
                        v-model="firstname"
                        objectKey="firstname"
                        @onChange="checkErrors(false)"
                ></BaseInput3>
                <BaseInput3
                        :label="lastNameLabel"
                        v-model="lastname"
                        objectKey="lastname"
                        @onChange="checkErrors(false)"
                ></BaseInput3>

                <BaseInput3
                        v-if="role && role !== 'вектор'"
                        label="Отчество"
                        v-model="surname"
                ></BaseInput3>

                <BaseInput3
                        label="Телефон"
                        v-model="phone"
                        objectKey="phone"
                        @onChange="checkErrors(false)"
                ></BaseInput3>

                <div id="user_form" class="field checkbox__wrapper">
                    <input @change="checkErrors(false)" type="checkbox" id="user_edit_data_accept" required="required"
                           v-model="allow">
                    <label class="req required" for="user_edit_data_accept">Я подтверждаю, что ознакомлен и принимаю <a
                            href="/license" target="_blank">пользовательское соглашение</a> и <a href="/policy"
                                                                                                 target="_blank">условия
                        конфиденциальности</a></label>
                </div>

                <div class="errors-block" v-show="errors.length">
                    <b>Пожалуйста, заполните поля:</b>
                    <ul>
                        <li style="color: red" v-for="(error,index) in errors" :key="index" v-html="error"></li>
                    </ul>
                </div>

                <div class="field" style="margin-top: 0.75rem;">
                    <button id="submit_button" style="width: 100%" class="button_login" @click="saveData">Регистрация
                    </button>
                </div>
						</template>
        </template>

    </div>
    <div v-else>
        <BaseLoader></BaseLoader>
    </div>
</template>

<script>
import axios from "axios";
import BaseInput3 from "./Base/BaseInput3"
import BaseLoader from "./Base/BaseLoader"
import BaseInputPassword from "./Base/BaseInputPassword"
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faEye, faEyeSlash} from '@fortawesome/free-solid-svg-icons';
import { Modal, Select, Alert } from 'ant-design-vue';

library.add(faEye);
library.add(faEyeSlash);

const validatinRules = [
  {
    fieldName: 'email',
    isRequired: true,
    errorText: 'Поле "Почта" обязательно для заполнения'
  },
  {
    fieldName: 'email',
    isEmail: true,
    errorText: 'Поле "Почта" должна быть в формате email'
  },
  {
    fieldName: 'password',
    isRequired: true,
    errorText: 'Поле "Пароль" обязательно для заполнения'
  },
  {
    fieldName: 'repeatPassword',
    isRequired: true,
    errorText: 'Поле "Повторите пароль" обязательно для заполнения'
  },
  {
    fieldName: 'firstname',
    isRequired: true,
    roles: ['ROLE_PARTICIPANT', 'ROLE_EXPERT', 'ROLE_ORGANIZATOR', 'ROLE_COMISSION'],
    errorText: 'Поле "Имя" обязательно для заполнения'
  },
  {
    fieldName: 'lastname',
    isRequired: true,
    roles: ['ROLE_PARTICIPANT', 'ROLE_EXPERT', 'ROLE_ORGANIZATOR', 'ROLE_COMISSION'],
    errorText: 'Поле "Фамилия" обязательно для заполнения'
  },
  {
    fieldName: 'firmName',
    isRequired: true,
    roles: ['ROLE_COMPANY'],
    errorText: 'Поле "Название компании" обязательно для заполнения'
  },
	{
    fieldName: 'phone',
    isRequired: true,
    roles: ['ROLE_PARTICIPANT', 'ROLE_EXPERT', 'ROLE_ORGANIZATOR', 'ROLE_COMISSION'],
    errorText: 'Поле "Телефон" обязательно для заполнения'
  },
  {
    fieldName: 'allow',
    isRequired: true,
    errorText: 'Необходимо согласиться с пользовательским соглашением и условиями конфиденциальности'
  }
];

export default {
  name: "RegistrationPage",
  data() {
    return {
      role: '',
      email: '',
      password: '',
      repeatPassword: '',
      firstname: '',
      lastname: '',
      surname: '',
      firmName: '',
      phone: '',
      allow: '',
			roles: [
        {
          'value': 'ROLE_PARTICIPANT',
          'label': 'Участник'
        },
        {
          'value': 'ROLE_EXPERT',
          'label': 'Эксперт'
        },
        {
          'value': 'ROLE_ORGANIZATOR',
          'label': 'Организатор'
        },
        {
          'value': 'ROLE_COMISSION',
          'label': 'Кинокомиссия'
        },
        {
          'value': 'Площадка',
          'label': 'Площадка'
        },
        {
          'label': 'Компания',
          'value': 'ROLE_COMPANY'
        },
        // {
        //   'label': 'Координатор площадок',
        //   'value': 'ROLE_AREA_CORDINATOR'
        // }
			],
      errors: [],
      passwordShow: false,
      passwordRepeatShow: false,
      isSubmitted: false,
      isDataUpdating: false,
      isLoading: true,
      hiddenCounter: 1,
      validationRules: structuredClone(validatinRules)
    }
  },
  components: {
    BaseInput3,
    FontAwesomeIcon,
    BaseInputPassword,
    BaseLoader,
    Modal,
		Select,
    Alert
  },
  mounted: function () {
    if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
    }

    this.getData();
  },
  methods: {
    getData: function () {
      this.isLoading = false;
    },
    onSubmit() {},
    saveData: function () {
      const self = this;
      this.isSubmitted = true;

      this.checkErrors();

      if (this.errors.length === 0 && !self.isLoading) {
        self.isLoading = true;

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = '/registration/new';


        const input1 = document.createElement('input');
        input1.type = 'hidden';
        input1.name = 'email';
        input1.value = this.email;
        form.appendChild(input1);

        const input2 = document.createElement('input');
        input2.type = 'hidden';
        input2.name = 'password';
        input2.value = this.password;
        form.appendChild(input2);

        const input3 = document.createElement('input');
        input3.type = 'hidden';
        input3.name = 'phone';
        input3.value = this.phone;
        form.appendChild(input3);

        const input4 = document.createElement('input');
        input4.type = 'hidden';
        input4.name = 'role';
        input4.value = this.role;
        form.appendChild(input4);

        const input5 = document.createElement('input');
        input5.type = 'hidden';
        input5.name = 'firstname';
        input5.value = this.firstname;
        form.appendChild(input5);

        const input6 = document.createElement('input');
        input6.type = 'hidden';
        input6.name = 'lastname';
        input6.value = this.lastname;
        form.appendChild(input6);

        const input7 = document.createElement('input');
        input7.type = 'hidden';
        input7.name = 'surname';
        input7.value = this.surname;
        form.appendChild(input7);

        const input8 = document.createElement('input');
        input8.type = 'hidden';
        input8.name = 'firmName';
        input8.value = this.firmName;
        form.appendChild(input8);

        document.body.appendChild(form);

        form.submit();

        // axios.post('/registration/new', null, {
        //   params: {
        //     'email': this.email,
        //     'password': this.password,
        //     'phone': this.phone,
        //     'role': this.role,
        //     'firstname': this.firstname,
        //     'lastname': this.lastname,
        //     'surname': this.surname,
				// 		'firmName': this.firmName
        //   }
        // }).then((response) => {
        //   self.isLoading = false;
        //   if (response.data === 'Это пользователь уже добавлен.') {
        //     alert(response.data);
        //   } else {
        //     if (this.role === 'вектор') {
        //       Modal.info(
        //         {
        //           'content': 'Вы успешно зарегистрировались',
        //           onOk() {
        //             window.location.replace("/project/forum_form");
        //           },
        //         }
        //       )
        //     } else {
        //       Modal.info(
        //         {
        //           'content': 'Вы успешно зарегистрировались',
        //           onOk() {
        //             window.location.replace("/");
        //           },
        //         }
        //       )
        //     }
        //   }
        // })
      } else {
        self.isLoading = false;
      }
    },
    handleRadio: function () {
      if (this.role === 'Площадка') {
        if (window.confirm("Для регистрации в качестве площадки необходимо заполнить специальную форму. Продолжить?") == true) {
          window.location.replace("/area/quiz");
        } else {
          this.role = '';
        }
      }
    },
    isFieldRequired(fieldName) {
      let res = false;
      this.validationRules.forEach(function (field) {
        if (
          (field.fieldName === fieldName || field?.altFieldName === fieldName)
          && field.isRequired) {
          res = true;
        }
      });
      return res;
    },
    isValidEmail(email) {
      // Регулярное выражение для проверки на валидность email
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

      return emailRegex.test(email);
    },
    validateField(field) {
      const self = this;

      if ('roles' in field && !field.roles.includes(this.role)) {
        return;
      }

      if (field.isRequired && (self[field.fieldName] === null || self[field.fieldName] === false || self[field.fieldName].length === 0 || self[field.fieldName] === 0)) {
        if (!self.errors.includes(field.errorText)) {
          if (field.fieldName === 'firstname' && this.role === 'вектор') {
            self.errors.push('Поле "' + this.nameLabel + '" обязательно для заполнения');
          } else if (field.fieldName === 'lastname' && this.role === 'вектор') {
            self.errors.push('Поле "' + this.lastNameLabel + '" обязательно для заполнения');
          } else {
            self.errors.push(field.errorText);
          }
        }
      }
      if ("isEmail" in field && field.isEmail && !this.isValidEmail(self[field.fieldName])) {
        if (!self.errors.includes(field.errorText)) {
          self.errors.push(field.errorText);
        }
      }
    },
    checkErrors(withScroll = true) {
      if (this.isSubmitted) {
        const self = this;
        this.needCheck = false;
        self.errors = [];

        if (this.password !== this.repeatPassword) {
          self.errors.push('Поле "Пароль" и "Повторите пароль" должны совпадать"');
        }

        this.validationRules.forEach(function (field) {
          self.validateField(field)
        });

        if (withScroll) {
          if (self.errors.length > 0) {
            document.getElementById("user_form").scrollIntoView();
          }
        }
      }
    },
    hiddenHandle() {
      this.hiddenCounter = this.hiddenCounter + 1;
      if (this.hiddenCounter === 5) {

        this.roles.push({
          'label': 'Участник кинофорума "Новый вектор"',
          'value': 'вектор'
        });
			}
		}
  },
  computed: {
    nameLabel() {
      if (this.role === 'вектор') {
        return 'Имя представителя организации';
      }
      return 'Имя';
    },
    lastNameLabel() {
      if (this.role === 'вектор') {
        return 'Фамилия представителя организации';
      }
      return 'Фамилия';
    },
		notice() {
			return window.notice;
		}
  },
	watch: {
		role(value) {
			if (value === 'Площадка') {
				if (window.confirm("Для регистрации в качестве площадки необходимо заполнить специальную форму. Продолжить?") == true) {
					window.location.replace("/area/quiz");
				} else {
					this.role = '';
				}
			}
		}
	}
}
</script>

<style scoped>

</style>